export const claimStrings = {
  en: {
    eyebrow: "Check my case",
    titleA: "Think you have",
    titleB: "unclaimed money?",
    intro:
      "Tell me a little about your situation and I\u2019ll personally look for a match. It takes one minute \u2014 and it\u2019s the perfect pre-work before your 1-on-1.",
    trust: [
      "No upfront fees \u2014 ever",
      "20% only after a successful recovery",
      "Limited authorization, explained and signed by you",
    ],
    nameLabel: "Your name *",
    namePh: "First and last name",
    contactLabel: "Phone or email *",
    contactPh: "808-000-0000 or you@email.com",
    fundLabel: "What kind of funds?",
    fundOptions: ["Undeposited / open check", "Unclaimed cash", "Dormant account", "Not sure"],
    amountLabel: "Rough amount (optional)",
    amountOptions: ["Under $1,000", "$1,000 \u2013 $10,000", "$10,000 \u2013 $50,000", "Over $50,000", "Not sure"],
    messageLabel: "Anything else? (optional)",
    messagePh: "Where the funds might be from, a business name, old addresses...",
    submit: "Send my case",
    sending: "Sending...",
    successTitle: "Mahalo \u2014 your case is in.",
    successBody:
      "I\u2019ll personally review it and reach out within one business day. Want to move faster? Book a 1-on-1 and we\u2019ll go through it together.",
    successCta: "Book a 1-on-1",
    error: "Something didn\u2019t go through \u2014 please try again, or text me directly at 808-298-4096.",
    consent: "No upfront fees. You pay the 20% share only if we recover successfully.",
    footerLink: "Check my case",
  },
  vi: {
    eyebrow: "Kiểm tra vụ việc của bạn",
    titleA: "Có thể bạn đang có",
    titleB: "tiền chưa được nhận.",
    intro:
      "Chia sẻ đôi chút về tình huống của bạn và tôi sẽ trực tiếp tìm kiếm kết quả trùng khớp. Chỉ mất một phút — và là bước chuẩn bị hoàn hảo trước buổi tư vấn 1-1.",
    trust: [
      "Không thu phí trước — không bao giờ",
      "Chỉ 20% sau khi thu hồi thành công",
      "Ủy quyền có giới hạn, được giải thích và bạn ký tên",
    ],
    nameLabel: "Tên của bạn *",
    namePh: "Họ và tên",
    contactLabel: "Số điện thoại hoặc email *",
    contactPh: "808-000-0000 hoặc you@email.com",
    fundLabel: "Loại khoản tiền?",
    fundOptions: ["Séc chưa gửi / séc chưa nhận", "Tiền mặt chưa nhận", "Tài khoản không hoạt động", "Không chắc chắn"],
    amountLabel: "Số tiền ước tính (không bắt buộc)",
    amountOptions: ["Dưới $1,000", "$1,000 \u2013 $10,000", "$10,000 \u2013 $50,000", "Trên $50,000", "Không chắc chắn"],
    messageLabel: "Thông tin thêm? (không bắt buộc)",
    messagePh: "Nguồn gốc khoản tiền, tên doanh nghiệp, địa chỉ cũ...",
    submit: "Gửi vụ việc của tôi",
    sending: "Đang gửi...",
    successTitle: "Mahalo — đã nhận vụ việc của bạn.",
    successBody:
      "Tôi sẽ trực tiếp xem xét và liên hệ với bạn trong vòng một ngày làm việc. Muốn nhanh hơn? Đặt lịch 1-1 và chúng ta sẽ cùng xem xét.",
    successCta: "Đặt lịch 1-1",
    error: "Có lỗi xảy ra — vui lòng thử lại, hoặc nhắn tin trực tiếp cho tôi theo số 808-298-4096.",
    consent: "Không thu phí trước. Bạn chỉ trả 20% nếu chúng tôi thu hồi thành công.",
    footerLink: "Kiểm tra vụ việc",
  },
  ko: {
    eyebrow: "내 사례 확인",
    titleA: "찾지 못한 돈이",
    titleB: "있으신가요?",
    intro:
      "상황을 조금만 알려주시면 제가 직접 일치하는 건을 찾아보겠습니다. 1분이면 충분합니다 — 1:1 상담 전 완벽한 사전 준비입니다.",
    trust: [
      "선불 없음 — 절대로",
      "성공적인 회복 이후에만 20%",
      "제한된 위임, 설명 후 고객님 서명",
    ],
    nameLabel: "성함 *",
    namePh: "이름과 성",
    contactLabel: "전화번호 또는 이메일 *",
    contactPh: "808-000-0000 또는 you@email.com",
    fundLabel: "어떤 종류의 자금인가요?",
    fundOptions: ["미입금 / 미수령 수표", "미수령 현금", "휴면 계좌", "확실하지 않음"],
    amountLabel: "대략적인 금액 (선택)",
    amountOptions: ["$1,000 미만", "$1,000 \u2013 $10,000", "$10,000 \u2013 $50,000", "$50,000 초과", "확실하지 않음"],
    messageLabel: "추가 정보 (선택)",
    messagePh: "자금 출처, 사업체 이름, 이전 주소 등...",
    submit: "내 사례 보내기",
    sending: "보내는 중...",
    successTitle: "마할로 — 사례가 접수되었습니다.",
    successBody:
      "제가 직접 검토하고 영업일 하루 안에 연락드리겠습니다. 더 빠르게 진행하고 싶으신가요? 1:1 상담을 예약하고 함께 살펴보세요.",
    successCta: "1:1 상담 예약",
    error: "전송에 문제가 있었습니다 — 다시 시도해 주시거나 808-298-4096으로 문자 주세요.",
    consent: "선불 없음. 성공적으로 회복했을 때만 20%를 받습니다.",
    footerLink: "내 사례 확인",
  },
};
